import { apiClient } from './ApiClient';

export interface ApiToken {
  id: number;
  name: string;
  description: string | null;
  isActive: boolean;
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  updatedAt: string;
  isExpired: boolean;
}

export interface CreateApiTokenRequest {
  name: string;
  description?: string | null;
  expiresInDays?: number | null;
}

export interface CreateApiTokenResponse extends ApiToken {
  token: string; // Only returned on creation
  warning: string;
}

export interface UpdateApiTokenRequest {
  name?: string;
  description?: string | null;
  is_active?: boolean;
}

class ApiTokenService {
  /**
   * Create a new API token
   */
  async createToken(
    data: CreateApiTokenRequest,
  ): Promise<CreateApiTokenResponse> {
    const response = await apiClient.post<CreateApiTokenResponse>(
      '/api-tokens',
      data,
    );
    return response.data;
  }

  /**
   * List all API tokens for the current user
   */
  async listTokens(): Promise<ApiToken[]> {
    const response = await apiClient.get<ApiToken[]>('/api-tokens');
    return response.data;
  }

  /**
   * Get a specific API token by ID
   */
  async getToken(id: number): Promise<ApiToken> {
    const response = await apiClient.get<ApiToken>(`/api-tokens/${id}`);
    return response.data;
  }

  /**
   * Update an API token
   */
  async updateToken(
    id: number,
    data: UpdateApiTokenRequest,
  ): Promise<ApiToken> {
    const response = await apiClient.put<ApiToken>(`/api-tokens/${id}`, data);
    return response.data;
  }

  /**
   * Revoke (deactivate) an API token
   */
  async revokeToken(id: number): Promise<void> {
    await apiClient.post(`/api-tokens/${id}/revoke`);
  }

  /**
   * Delete an API token permanently
   */
  async deleteToken(id: number): Promise<void> {
    await apiClient.delete(`/api-tokens/${id}`);
  }
}

export default new ApiTokenService();

